export default __webpack_public_path__ + "static/media/Grid.971d98aa.svg";